import { 
    Paper, 
    makeStyles,
    Grid,
    Container,
    Typography,
    Button,
    TextField,
    Tooltip,
    withStyles,
    withWidth,
    Hidden,
    AppBar,
    Toolbar,
} from '@material-ui/core'
import React , {useEffect} from 'react'
import { Autocomplete } from "@material-ui/lab";
import { useForm } from 'react-hook-form';
import Logo  from "../Assets/Logo.png";
import clienteAxios from "../../helpers/config-axios";
import axios from "axios";
import {solicitarToken} from "../../services/saeServices";
import { toastError, toastExito } from "../ToastMessage";


const useStyles = makeStyles((theme) => ({
    paper: {
        margin: 'auto',
        maxWidth: "800px",
        width: "90%",
        padding: "25px 75px 55px",
    },
    grid: {
        margin: theme.spacing(1),
        display: "flex"
    },
    title: {
        display: "block",
        textAlign: "center",
    },
    container: {
        backgroundColor: "#02728c",
        color: "#fff",
        minWidth: "400px",
        borderRadius: "8px",
        marginBottom: "30px",
        textAlign: "center",
        padding: "25px 30px",
    },
    button: {
        backgroundColor: "#02728c",
        color: "#fff",
        '&:hover': {
            backgroundColor: '#038aa9',
            boxShadow: 'none',
        },
        borderRadius: "50px",
        minHeight: "56px",
        width: "300px"
    },
    texto: {
        height: "70px",
        minWidth: "300px",
    },
    banner: {
        letterSpacing: "1px",
        fontWeight: "700",
        fontSize: "x-large",
    },
    tooltip: {
        maxWidth: 300,
    },
    toolBar: {
        backgroundColor: "#02728c",
        position: "relative",
    },
    logo: {
        height: "35px",
        width: "100px"
    },
  }));

const HtmlTooltip = withStyles((theme) => ({
tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
},
}))(Tooltip);

const FormSae = (props) => {

    const classes = useStyles();
    
    const [importancia, setImportancia] = React.useState("success");
    const [open, setOpen] = React.useState(false);
    const [selectServicio, setselectServicio] = React.useState({
        tipo_servicio: "",
    });
    const [selectRegion, setselectRegion] = React.useState({
        region: "",
        value: "",
    });
    const [itemsComunas, setitemsComunas] = React.useState([])
    const [selectComunas, setselectComunas] = React.useState({});

    const {handleSubmit} = useForm();

    const [textoAyuda, settextoAyuda] = React.useState({
        numero_contacto: "",
        nombre: "",
        apellido:  "",
        imei: "",
        tipo_servicio: "",
        marca_equipo: "",
        modelo_equipo: "",
        region: "",
        comuna: "",
    });
    const [invalid, setInvalid] = React.useState({
        numero_contacto: false,
        nombre: false,
        apellido: false,
        imei: false,
        marca_equipo: false,
        modelo_equipo: false,
        tipo_servicio: false,
        region: false,
        comuna: false,
    });
    const [valueForm, setValueForm] = React.useState({
        numero_contacto: "",
        nombre: "",
        apellido: "",
        imei: "",
        marca_equipo: "",
        modelo_equipo: "",
    });

    useEffect(()=>{
        obtenerToken();
    },[]);

    const obtenerToken = async () => {
        await solicitarToken();
    };

    const handleSnackbar = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
    };

    const onSubmit = (data) => {
        guardarFormulario();
    }

    const clear = () => {
        setValueForm({
            numero_contacto: "",
            nombre: "",
            apellido: "",
            imei: "",
            marca_equipo: "",
            modelo_equipo: "",
        });
        setselectServicio({
            tipo_servicio: "",
        });
        setselectRegion({
            region: "",
        });
        setselectComunas({
            comunas: "",
        });
    }

    const guardarFormulario = async() => {
        //console.log("value form", valueForm);
        if(valueForm.numero_contacto.length !== 9 || valueForm.numero_contacto.match("^[0-9]") === null){
            setInvalid({numero_contacto: true});
            settextoAyuda({numero_contacto: "tiene que ingresar un número válido de 9 dígitos"});
        }
        else if(valueForm.nombre.length > 20 || valueForm.nombre.match("^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$") === null || valueForm.nombre.length === 0){
            setInvalid({nombre: true});
            settextoAyuda({nombre: "debe ingresar un Nombre válido"});
        }
        else if(valueForm.apellido.length > 20 || valueForm.apellido.match("^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$") === null || valueForm.apellido.length === 0){
            setInvalid({apellido: true});
            settextoAyuda({apellido: "debe ingresar un Apellido válido"});
        }
        else if(valueForm.imei.length !== 15 || valueForm.imei.match("^[0-9]") === null){
            setInvalid({imei: true});
            settextoAyuda({imei: "debe ingresar un imei"});
        }
        else if(valueForm.marca_equipo.match("^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$") === null){
            settextoAyuda({marca_equipo: "debe ingresar una marca de equipo válida"});
            setInvalid({marca_equipo: true});
        }
        else if(valueForm.modelo_equipo.match("^[a-zA-Z0-9À-ÿ\u00f1\u00d1]+(\s*[a-zA-Z0-9À-ÿ\u00f1\u00d1]*)*[a-zA-Z0-9À-ÿ\u00f1\u00d1]+$") === null){
            settextoAyuda({modelo_equipo: "debe ingresar un modelo de equipo válido"});
            setInvalid({modelo_equipo: true});
        }
        else if(selectServicio.tipo_servicio === ""){
            setInvalid({tipo_servicio: true});
            settextoAyuda({tipo_servicio: "ingrese un tipo de servicio"});
        }
        else if(selectRegion.region === ""){
            setInvalid({region: true});
            settextoAyuda({region: "ingrese una Region "});
        }
        else if(selectComunas.comuna === ""){
            setInvalid({comuna: true});
            settextoAyuda({comuna: "ingrese una Comuna"});
        }
        else{
            //console.log("puedo mandar la api tranquilamente")
            try {
                await axios.post("https://gw-clientes.mundopacifico.cl/api/sae/guardarSae", {
                    numero_contacto: valueForm.numero_contacto,
                    nombre: valueForm.nombre,
                    apellido: valueForm.apellido,
                    imei: valueForm.imei,
                    marca_equipo: valueForm.marca_equipo,
                    modelo_equipo: valueForm.modelo_equipo,
                    tipo_servicio: selectServicio.tipo_servicio,
                    region: selectRegion.region,
                    comuna: selectComunas.comuna,
                })
                .then((response) => {
                    handleSnackbar();
                    //console.log("Respuesta", response);
                    if (response.status === 200) {
                        toastExito("Registro guardado exitosamente");
                        clear();
                    }else{
                        toastError("Error al guardar el registro");
                    }
                })
            } catch(error) {
                toastError("Error al guardar el registro");
            }
        }
    };

    const handleContactoChange = (event) => {
        const { value } = event.target;
        setValueForm({...valueForm, numero_contacto: value});
        settextoAyuda({numero_contacto: ""});
        setInvalid({numero_contacto: false});
    };

    const handleNombreChange = (event) => {
        const { value } = event.target;
        setValueForm({...valueForm, nombre: value});
        settextoAyuda({nombre: ""});
        setInvalid({nombre: false});
    };
    const handleApellidoChange = (event) => {
        const { value } = event.target;
        setValueForm({...valueForm, apellido: value});
        setInvalid({apellido: false});
        settextoAyuda({apellido: ""});
    };
    const handleImeiChange = (event) => {
        const { value } = event.target;
        setValueForm({...valueForm, imei: value});
        setInvalid({imei: false});
        settextoAyuda({imei: ""});
    };
    const handleMarcaChange = (event) => {
        const { value } = event.target;
        setValueForm({...valueForm, marca_equipo: value});
        
        setInvalid({marca_equipo: false});
        settextoAyuda({marca_equipo: ""});
    };
    const handleModeloChange = (event) => {
        const { value } = event.target;
        setValueForm({...valueForm, modelo_equipo: value});
        
        setInvalid({modelo_equipo: false});
        settextoAyuda({modelo_equipo: ""});
    };
    const handleServicioChange = (newValue) => {
        //console.log(newValue);
        if (newValue === null || typeof newValue === "undefined"){
            setselectServicio({TipoServicio: ""});
        } else {
            //console.log(newValue)
            setselectServicio({tipo_servicio: newValue.nombre});
            setInvalid({tipo_servicio: false});
            settextoAyuda({tipo_servicio: ""});
        }
    };

    const handleRegionChange = (newValue) => {
        if (newValue === null || typeof newValue === "undefined"){
            setselectRegion({
                region: ""});
        } else {
            //console.log(newValue)
            setselectRegion({region: newValue.nombre, value: newValue.codigo});
            setInvalid({region: false});
            settextoAyuda({region: ""});
        }
    };
    
    useEffect(() => {
        if(selectRegion.region){
            cargarComunas();
        }
    }, [selectRegion.region]);

    const cargarComunas = async() => {
        await clienteAxios.get(`api/mutualidad/comunas?codigoRegion=${selectRegion.value}`)
        .then((response) => {
            setitemsComunas(response.data.success.descripcionRespuesta.data);
        })
        .catch(error => {
            //console.log("error api comunas", error);
        })
    };

    const handleComunaChange = (newValue) => {
        if (newValue === null || typeof newValue === "undefined"){
            setselectComunas({
                comuna: ""
            });
        } else {
            //console.log("bandera comuna", newValue);
            setselectComunas({comuna: newValue.label});
            setInvalid({comuna: false});
            settextoAyuda({comuna: ""});
            //console.log(selectComunas.comuna);
        }
    };

    return (
        <div>
            <Hidden mdUp>
                <AppBar>
                    <Toolbar className={classes.toolBar}>
                        <img className={classes.logo} src={Logo}/>
                        <Typography
                        >
                            Formulario del sistema de emergencia ONEMI
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Grid className={classes.grid} justify="center">
                    <TextField
                        error = {invalid.numero_contacto}
                        helperText = {textoAyuda.numero_contacto}
                        className = {classes.texto}
                        label = "Número Contacto"
                        placeholder = "E: 912345678 (9 digitos)"
                        value = {valueForm.numero_contacto}
                        variant = "outlined"
                        onChange = {handleContactoChange}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <TextField
                        error = {invalid.nombre}
                        helperText = {textoAyuda.nombre}
                        className = {classes.texto}
                        label = "Nombre"
                        placeholder = "Ej: Pedro"
                        value = {valueForm.nombre}
                        variant = "outlined"
                        onChange = {handleNombreChange}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <TextField
                        error = {invalid.apellido}
                        helperText = {textoAyuda.apellido}
                        className = {classes.texto}
                        label = "Apellido"
                        placeholder = "Ej: Gonzáles"
                        value = {valueForm.apellido}
                        variant = "outlined"
                        onChange = {handleApellidoChange}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">   
                    <HtmlTooltip
                        title={
                            <React.Fragment>
                                <Typography color="inherit">obtén el número de <b>IMEI</b> marcando <b>*#06#</b> en tu teléfono</Typography>
                            </React.Fragment>
                        }
                        arrow
                        interactive
                        placement="right"
                    >
                        <TextField
                            error = {invalid.imei}
                            helperText = {textoAyuda.imei}
                            className = {classes.texto}
                            label = "IMEI"
                            placeholder = "Ej: 123456789012345"
                            value = {valueForm.imei}
                            variant = "outlined"
                            onChange = {handleImeiChange}
                        />    
                    </HtmlTooltip>
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <TextField
                        error = {invalid.marca_equipo}
                        helperText = {textoAyuda.marca_equipo}
                        className = {classes.texto}
                        label = "Marca Equipo"
                        placeholder = "Ej: Marca"
                        value = {valueForm.marca_equipo}
                        variant = "outlined"
                        onChange = {handleMarcaChange}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <TextField
                        error = {invalid.modelo_equipo}
                        helperText = {textoAyuda.modelo_equipo}
                        className = {classes.texto}
                        label = "Modelo Equipo"
                        placeholder = "Ej: Modelo"
                        value = {valueForm.modelo_equipo}
                        variant = "outlined"
                        onChange = {handleModeloChange}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <Autocomplete
                        id="select_tipo_servicio"
                        name="select_tipo_servicio"
                        options={TipoServicio}
                        getOptionLabel={(option) => option.nombre}
                        onChange={(event, newValue) => {
                            if(newValue !== null) {
                                handleServicioChange(newValue);
                            } else {
                                setselectServicio({tipo_servicio: ""});
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            className={classes.texto}
                            error={invalid.tipo_servicio}
                            helperText={textoAyuda.tipo_servicio}
                            label="Tipo Servicio"
                            variant="outlined"
                            name="txt_servicio"
                            />
                        )}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">  
                    <Autocomplete
                        id="select_region"
                        name="select_region"
                        options={Regiones}
                        getOptionLabel={(option) => option.nombre}
                        onChange={(event, newValue) => {
                            if(newValue !== null) {
                                handleRegionChange(newValue);
                            }
                            else {
                                setselectRegion({region: ""});
                                setitemsComunas([]);
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            className={classes.texto}
                            error={invalid.region}
                            helperText={textoAyuda.region}
                            label="Regiones"
                            variant="outlined"
                            name="txt_regiones"
                            />
                        )}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <Autocomplete
                        id="select_comuna"
                        name="select_comuna"
                        options={
                            itemsComunas.map((item, index) => ({
                                label: item.descripcion,
                                value: item.codigo,
                            }))
                        }
                        getOptionLabel={(itemsComunas) => itemsComunas.label}
                        onChange={(event, newValue) => {
                            if(newValue !== null) {
                                handleComunaChange(newValue);
                            }
                            else {
                                setselectComunas({Comuna: ""});
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            className={classes.texto}
                            error={invalid.comuna}
                            helperText={textoAyuda.comuna}
                            label="Comunas"
                            variant="outlined"
                            name="txt_Comunas"
                            />
                        )}
                    />
                </Grid>
                <Grid className={classes.grid} justify="center">
                    <Button 
                        className={classes.button}
                        onClick={onSubmit}
                    >
                        Enviar
                    </Button>
                </Grid>
            </Hidden>
            <Hidden smDown>
                <Paper className={classes.paper}>
                    <Container className={classes.container}>
                        <img src={Logo}/>
                        <Typography 
                            className={classes.banner}
                        >
                            Formulario SAE
                        </Typography>
                        <Typography>
                            Informa tu problema
                        </Typography>
                    </Container>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <TextField
                                error = {invalid.numero_contacto}
                                helperText = {textoAyuda.numero_contacto}
                                className = {classes.texto}
                                label = "Número Contacto"
                                placeholder = "E: 912345678 (9 digitos)"
                                value = {valueForm.numero_contacto}
                                variant = "outlined"
                                onChange = {handleContactoChange}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <TextField
                                error = {invalid.nombre}
                                helperText = {textoAyuda.nombre}
                                className = {classes.texto}
                                label = "Nombre"
                                placeholder = "Ej: Pedro"
                                value = {valueForm.nombre}
                                variant = "outlined"
                                onChange = {handleNombreChange}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <TextField
                                error = {invalid.apellido}
                                helperText = {textoAyuda.apellido}
                                className = {classes.texto}
                                label = "Apellido"
                                placeholder = "Ej: Gonzáles"
                                value = {valueForm.apellido}
                                variant = "outlined"
                                onChange = {handleApellidoChange}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>   
                            <HtmlTooltip
                                title={
                                    <React.Fragment>
                                        <Typography color="inherit">obtén el número de <b>IMEI</b> marcando <b>*#06#</b> en tu teléfono</Typography>
                                    </React.Fragment>
                                }
                                arrow
                                interactive
                                placement="right"
                            >
                                <TextField
                                    error = {invalid.imei}
                                    helperText = {textoAyuda.imei}
                                    className = {classes.texto}
                                    label = "IMEI"
                                    placeholder = "Ej: 123456789012345"
                                    value = {valueForm.imei}
                                    variant = "outlined"
                                    onChange = {handleImeiChange}
                                />    
                            </HtmlTooltip>
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <TextField
                                error = {invalid.marca_equipo}
                                helperText = {textoAyuda.marca_equipo}
                                className = {classes.texto}
                                label = "Marca Equipo"
                                placeholder = "Ej: Marca"
                                value = {valueForm.marca_equipo}
                                variant = "outlined"
                                onChange = {handleMarcaChange}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <TextField
                                error = {invalid.modelo_equipo}
                                helperText = {textoAyuda.modelo_equipo}
                                className = {classes.texto}
                                label = "Modelo Equipo"
                                placeholder = "Ej: Modelo"
                                value = {valueForm.modelo_equipo}
                                variant = "outlined"
                                onChange = {handleModeloChange}
                            />
                        </Grid>
                        <Grid className={classes.grid} item xs={12} justify="center">
                            <Autocomplete
                                id="select_tipo_servicio"
                                name="select_tipo_servicio"
                                options={TipoServicio}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(event, newValue) => {
                                    if(newValue !== null) {
                                        handleServicioChange(newValue);
                                    } else {
                                        setselectServicio({tipo_servicio: ""});
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    className={classes.texto}
                                    error={invalid.tipo_servicio}
                                    helperText={textoAyuda.tipo_servicio}
                                    label="Tipo Servicio"
                                    variant="outlined"
                                    name="txt_servicio"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>  
                            <Autocomplete
                                id="select_region"
                                name="select_region"
                                options={Regiones}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(event, newValue) => {
                                    if(newValue !== null) {
                                        handleRegionChange(newValue);
                                    }
                                    else {
                                        setselectRegion({region: ""});
                                        setitemsComunas([]);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    className={classes.texto}
                                    error={invalid.region}
                                    helperText={textoAyuda.region}
                                    label="Regiones"
                                    variant="outlined"
                                    name="txt_regiones"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <Autocomplete
                                id="select_comuna"
                                name="select_comuna"
                                options={
                                    itemsComunas.map((item, index) => ({
                                        label: item.descripcion,
                                        value: item.codigo,
                                    }))
                                }
                                getOptionLabel={(itemsComunas) => itemsComunas.label}
                                onChange={(event, newValue) => {
                                    if(newValue !== null) {
                                        handleComunaChange(newValue);
                                    }
                                    else {
                                        setselectComunas({Comuna: ""});
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                    {...params}
                                    className={classes.texto}
                                    error={invalid.comuna}
                                    helperText={textoAyuda.comuna}
                                    label="Comunas"
                                    variant="outlined"
                                    name="txt_Comunas"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid className={classes.grid} justify="center" item xs={12}>
                            <Button 
                                className={classes.button}
                                onClick={onSubmit}
                            >
                                Enviar
                            </Button>
                        </Grid>
                    </form>
                </Paper>
            </Hidden>
        </div>
    )
}

export default withWidth()(FormSae)

const Regiones = [
    {nombre: "Región de Tarapacá", codigo: 1},
    {nombre: "Región de Antofagasta", codigo: 2},
    {nombre: "Región de Atacama", codigo: 3},
    {nombre: "Región de Coquimbo", codigo: 4},
    {nombre: "Región de Valparaíso", codigo: 5},
    {nombre: "Región del Libertador General Bernardo O'Higgins ", codigo: 6},
    {nombre: "Región del Maule", codigo: 7},
    {nombre: "Región del Biobío", codigo: 8},
    {nombre: "Región de la Araucanía ", codigo: 9},
    {nombre: "Región de Los Lagos", codigo: 10},
    {nombre: "Región de Aísen", codigo: 11},
    {nombre: "Región de Magallanes y de la Antártica Chilena", codigo: 12},
    {nombre: "Región Metropolitana de Santiago", codigo: 13},
    {nombre: "Región de los Ríos", codigo: 14},
    {nombre: "Región de Arica y Parinacota", codigo: 15},
    {nombre: "Región de Ñuble", codigo: 16},
];

const TipoServicio = [
    {nombre: "Plan", codigo: 1},
    {nombre: "Prepago", codigo: 2},
];